import React from 'react';

import {Heading, Text} from '@albert-io/atomic';

import CoppaMessage from './CoppaMessage';

export default function CoppaError() {
  return (
    <CoppaMessage>
      <Heading as='div'>Error</Heading>
      <Text paragraph as='p'>
        We couldn&apos;t process your request. This may be because you or somebody else has already
        approved this student or because we&apos;ve already deleted their account. Please contact
        hello@albert.io if you have questions or concerns.
      </Text>
    </CoppaMessage>
  );
}
